import { useEffect } from "react";
import { BaseUrl } from "../..";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import topTost from "../../utils/topTost";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import Content2Header from "./Content2Header";
import { fetchFormData } from "../../utils/options";
const EditPdf = () => {
  const [pdf, setPdf] = useState([
    { file: null, name: "", base64: "", previewUrl: "", isNew: true, text: "" },
  ]);
  const [details, setDetails] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!token) navigate("/");
  }, []);

  // Convert File -> Base64
  const toBase64 = (file) => {
    return new Promise((resolve) => {
      if (!file) return resolve(null);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });
  };
  // Update image
  const updateFile = async (index, file) => {
    if (!file) return;

    const base64 = await toBase64(file);
    const previewUrl = URL.createObjectURL(file);
    setPdf((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        file,
        base64,
        previewUrl,
     
        name: file.name,
        isNew: true,
      };
      return updated;
    });
  };

  // content by id
  const contentbyId = async () => {
    try {
      const response = await fetch(`${BaseUrl}contentbyid/${id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const data = result?.result?.data;
      setDetails(data);
      const resultArr = data?.pdf || [];

      if (resultArr.length > 0) {
        setPdf(
          resultArr.map((p) => ({
            file: p.pdf_url || "",
            name: p.pdf_file || "",
            text:p.text || ""
          }))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (id) {
      contentbyId();
    }
  }, []);
  // Add new Pdf
  const addPdf = () =>
    setPdf((prev) => [
      ...prev,
      {
        file: null,
        name: "",
        base64: "",
        previewUrl: "",
        isNew: true,
        text: "",
      },
    ]);

  // update
  const updatePdf = async () => {
  const invalidRow = pdf.find((p) => p.text && !p.file && !p.base64);
  if (invalidRow) {
    topTost({ title: "Please select a PDF file for the entered text", icon: "error" });
    return;
  }

    const payload = {
      id: id,
      Pdf: pdf.map((p) => {
        if (p.isNew) return { file: p.base64, text: p.text };

        return { file: p.file, text: p.text };
      }),
    };

    try {
      const response = await fetch(`${BaseUrl}update-content-pdf`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();

      if (result?.result?.code === 200) {
        topTost({ title: result?.result?.message, icon: "success" });
        setTimeout(() => {
          navigate("/master/topic-list");
        }, 600);

        return;
      } else {
        topTost({
          title: result?.result?.message || "Update failed",
          icon: "error",
        });
      }
    } catch (error) {
      console.log(error);
      topTost({ title: "Something went wrong", icon: "error" });
    }
  };

  const getPdfPath = (fullUrl) => {
    if (!fullUrl) return "";
    try {
      const url = new URL(fullUrl);
      return url.pathname.replace(/^\/+/, "");
    } catch {
      return fullUrl;
    }
  };

  const handleRemovePdf = async (item, index) => {
    if (!item.isNew && item.file) {
      const path = getPdfPath(item.file);
      await removeContent(path, index);
    } else {
      setPdf((prev) => prev.filter((_, i) => i !== index));
      topTost({
        title:
          "Content removed. Click Update to permanently remove this content.",
        icon: "info",
      });
    }
  };
  //remove content api

  const removeContent = async (urlPath, index) => {
    if (!urlPath) return;

    const form = new FormData();
    form.append("url", urlPath);

    try {
      const result = await fetchFormData(
        "content/remove-ContentFile",
        form,
        "POST"
      );

      if (result?.success || result?.code === 200) {
        topTost({
          title:
            "Content removed. Click Update to permanently remove this content.",
          icon: "info",
        });

        // Only remove from state
        setPdf((prev) => prev.filter((_, i) => i !== index));
      } else {
        topTost({
          title: "Failed to remove PDF",
          icon: "error",
        });
      }
    } catch (error) {
      console.log(error);
      topTost({ title: "Something went wrong", icon: "error" });
    }
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            {" "}
            <Content2Header />
          </PageHeader>
          <div className="main-content">
            {/* Course Details */}

            <div className="card mb-4 fw-bold">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#0e606e" }}
              >
                Edit Pdf
              </div>
              <div className="card-body">
                <div className="row ">
                  <div className="col-md-6 mb-2">
                    <strong>Course:</strong> {details.course_name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Semester:</strong> {details.semester_name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Subject:</strong> {details.subject_name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Chapter:</strong> {details.chapter_name || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>Title:</strong> {details.title || "-"}
                  </div>
                  <div className="col-md-6 mb-2">
                    <strong>description:</strong> {details.description || "-"}
                  </div>
                </div>
              </div>
            </div>

            {/* PDF Uploads */}
            {/* PDF Uploads */}
            <div className="card mb-4">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <thead
                      style={{
                        display: "table-header-group",
                        backgroundColor: "#f1f1f1",
                        fontWeight: 600,
                      }}
                    >
                      <tr>
                        <th style={{ width: "50%" }}>Notes</th>
                        <th style={{ width: "20%" }}>Upload PDF</th>
                        <th style={{ width: "20%" }}>File Name</th>
                        <th style={{ width: "10%" }}>View</th>
                        <th style={{ width: "10%" }}>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {pdf.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <textarea
                              className="form-control"
                              rows={4}
                              placeholder="Enter notes..."
                              value={item.text}
                              onChange={(e) => {
                                const value = e.target.value;
                                setPdf((prev) => {
                                  const updated = [...prev];
                                  updated[index] = {
                                    ...updated[index],
                                    text: value,
                                  };
                                  return updated;
                                });
                              }}
                            />
                          </td>
                          {/* Upload */}
                          <td>
                            <input
                              type="file"
                              accept="application/pdf"
                              className="form-control form-control-sm"
                              onChange={(e) =>
                                updateFile(index, e.target.files[0])
                              }
                            />
                          </td>

                          {/* File Name */}
                          <td>
                            {item.name ? (
                              <span
                                className="text-truncate d-inline-block"
                                style={{ maxWidth: "250px" }}
                              >
                                {item.name}
                              </span>
                            ) : (
                              <span className="text-muted">No file</span>
                            )}
                          </td>

                          {/* View */}
                          <td className="text-center">
                            {item.previewUrl ? (
                              <a
                                href={item.previewUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                View PDF
                              </a>
                            ) : item.file ? (
                              <a
                                href={item.file} // existing server PDF
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                View PDF
                              </a>
                            ) : (
                              <span className="text-muted">—</span>
                            )}
                          </td>

                          {/* Action */}
                          <td className="text-center">
                            {(item.text || item.file) && (
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => handleRemovePdf(item, index)}
                              >
                                Remove
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Add PDF */}
              </div>
            </div>

            <button
              className="btn btn-outline-primary btn-sm mb-2"
              type="button"
              onClick={addPdf}
            >
              + Add More
            </button>
            <button className="btn btn-success " onClick={updatePdf}>
              Update Pdf
            </button>
          </div>
        </div>
      </main>
    </>
  );
};
export default EditPdf;
